(() => {
  const selector = '.uheat-feefo-product-reviews';
  const parentBySku = new Map();
  let selectedSku;
  let requestId = 0;

  const parentSkuFor = (sku) => {
    if (!parentBySku.has(sku)) {
      const url = new URL('https://api.feefo.com/api/20/reviews/summary/product');
      url.searchParams.set('merchant_identifier', 'uheat');
      url.searchParams.set('product_sku', sku);
      url.searchParams.set('since_period', 'all');
      const lookup = fetch(url.toString())
        .then((response) => {
          if (!response.ok) throw new Error('Feefo lookup failed');
          return response.json();
        })
        .then((data) => {
          const product = data?.product;
          const matches = Array.isArray(product?.sku) &&
            product.sku.some((item) => item.toLowerCase() === sku.toLowerCase());
          return matches && typeof product.parent_sku === 'string'
            ? product.parent_sku.trim()
            : '';
        })
        .catch(() => '');
      parentBySku.set(sku, lookup);
    }
    return parentBySku.get(sku);
  };

  const render = (root, sku, parentSku) => {
    const code = parentSku || sku;
    const attribute = parentSku ? 'parent-product-sku' : 'sku';
    const current = root.querySelector('feefo-product-reviews');
    if (!code || !current || current.getAttribute(attribute) !== code ||
        current.hasAttribute(parentSku ? 'sku' : 'parent-product-sku')) {
      current?.remove();
      if (code) {
        const widget = document.createElement('feefo-product-reviews');
        widget.setAttribute(attribute, code);
        root.appendChild(widget);
      }
    }
    const starsRoot = document.querySelector('.uheat-feefo-product-stars');
    const starsKey = attribute + ':' + code;
    if (starsRoot && starsRoot.dataset.feefoKey !== starsKey) {
      starsRoot.dataset.feefoKey = starsKey;
      starsRoot.querySelector('feefo-on-page-stars')?.remove();
      if (code) starsRoot.appendChild(document.createElement('feefo-on-page-stars'));
    }
    root.dataset.feefoResolvedCode = code;
    root.dataset.feefoResolvedType = parentSku ? 'parent' : 'sku';
  };

  const sync = async () => {
    const root = document.querySelector(selector);
    if (!root) return;
    let map;
    try { map = JSON.parse(root.dataset.feefoVariantMap || '{}'); } catch { return; }
    const variantId = new URLSearchParams(window.location.search).get('variant');
    const sku = variantId
      ? (Object.prototype.hasOwnProperty.call(map, variantId) ? map[variantId] : '')
      : root.dataset.feefoInitialSku || '';
    if (sku === selectedSku) return;
    selectedSku = sku;
    const thisRequest = ++requestId;
    const parentSku = sku ? await parentSkuFor(sku) : '';
    if (thisRequest !== requestId) return;
    const fallbackGroupSku = root.dataset.feefoFallbackGroupSku || '';
    render(root, parentSku ? sku : (fallbackGroupSku || sku), parentSku);
    if (!parentSku && fallbackGroupSku) root.dataset.feefoResolvedType = 'group';
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync, { once: true });
  else sync();
  window.addEventListener('popstate', sync);
  document.addEventListener('change', () => { setTimeout(sync, 100); setTimeout(sync, 500); }, true);
  setInterval(sync, 1000);
})();
